import React from "react"
import styled, { keyframes } from "styled-components"
import { color } from "../style/style"

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`

const LoaderWrapper = styled.div`
  position: fixed;
  inset: 0;
  background: white;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 6px solid #ccc;
  border-top-color: ${color.bronze};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`

const Loader = () => (
  <LoaderWrapper>
    <Spinner />
  </LoaderWrapper>
)

export default Loader
